module.exports = __webpack_public_path__ + "img/logo.cc9647f6.png";